export default {
  deposit: {
    crypto: 'Kripto',
    fiatOrCash: 'Fiat/Tunai',
    depositCurrency: 'Mata Wang Deposit',
    chooseNetwork: 'Pilih Rangkaian',
    depositAddress: 'Alamat deposit',
    copy: 'Salin',
    copied: 'Disalin!',
    close: 'Tutup',
    more: 'Lagi',
    select: 'Pilih',
    channel: 'Saluran',
    loading: 'Memuatkan...',
    noCurrency: 'Tiada mata wang tersedia',
    bonusTip: 'Nikmati bonus deposit pada caj semula pertama anda, dengan kredit tambahan sehingga 200%.',
    minDeposit: 'Deposit Minimum',
    sendOnly: 'Hantar hanya {currency} ke alamat deposit ini. Syiling akan didepositkan secara automatik selepas {confirmations} pengesahan rangkaian.',
    depositAmount: 'Jumlah Deposit',
    enterAmount: 'Masukkan jumlah',
    confirmDeposit: 'Sahkan Deposit',
    depositTitle: 'Deposit',
    selectChannel: 'Pilih Saluran',
    subtitle: 'Pantas, selamat dan mudah',
    secureEncrypted: 'Selamat dan Disulitkan',
    terms: 'Dengan meneruskan, anda bersetuju dengan Terma & Syarat kami',
    totalDepositAmount: 'Jumlah deposit keseluruhan',
    fee: 'Yuran',
    arrivalAmount: 'Jumlah yang dikreditkan',
    payMethod: 'Kaedah Pembayaran',
    cpf: 'CPF',
    enterCpf: 'Sila masukkan CPF anda',
    depositSuccess: 'Deposit berjaya!',
    depositFailed: 'Deposit gagal, sila cuba lagi.',
    mockArrive: 'Simulasi Masuk (Ujian)',
    activity: {
      firstChargeTitle: 'Acara Pendaftaran Caj Semula Pertama',
      firstChargeSubtitle: 'Daftarkan deposit pertama anda untuk menerima ganjaran eksklusif',
      dailyThreeTitle: 'Tiga Caj Semula Harian',
      dailyThreeSubtitle: 'Lengkapkan 3 deposit sehari untuk menuntut bonus tambahan',
      dailyPreviewLabel: 'Ganjaran Caj Semula Pertama',
      upTo: 'Sehingga {amount} {unit}',
      safeTitle: 'Dana anda selamat bersama kami',
      safeDesc: 'Kami menggunakan keselamatan terunggul industri untuk melindungi transaksi dan maklumat peribadi anda.',
      dailyFirst: 'Caj Semula Harian Ke-1',
      dailySecond: 'Caj Semula Harian Ke-2',
      dailyThird: 'Caj Semula Harian Ke-3',
      lossReward: 'Rebat Kerugian',
      lossRewardSubtitle: 'Dapatkan pulangan tunai atas kerugian anda',
      rebateUpTo: 'Rebat sehingga {ratio}%',
      notEligible: 'Anda tidak lagi layak untuk aktiviti ini',
      lossNeedSelect: 'Pilih aktiviti ini semasa deposit untuk menyertai cashback',
      claimed: 'Dituntut',
      claim: 'Tuntut',
      noTier: 'Tiada peringkat',
      claimWillOpen: 'Tuntutan dibuka pada {time}',
      claimTimeNotReached: 'Tuntutan belum dibuka. Sila kembali selepas {time}.',
      bonus: 'Bonus',
      rebate: 'Rebat',
      depositGE: 'Deposit ≥ {amount}',
      lossGE: 'Kerugian ≥ {amount}',
      claimSuccess: 'Berjaya dituntut',
      claimFailed: 'Tuntutan gagal',
      alreadyClaimed: 'Anda telah menuntut peringkat ini. Jangan klik lagi.',
      lossAlreadyClaimed: 'Anda telah menuntut rebat kerugian peringkat ini. Jangan klik lagi.',
      requireLogin: 'Sila log masuk sebelum menuntut.',
      depositNotEnough: 'Jumlah deposit anda belum memenuhi syarat. Teruskan!',
      lossNotEnough: 'Jumlah kerugian semalam belum memenuhi syarat.',
      onlyHighest: 'Ganjaran aktiviti ini hanya boleh dituntut pada peringkat tertinggi.',
    },
  },
};
